import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessagesCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 81,
	viewBox: "0 0 80 81",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: .75,
		width: 80,
		height: 80,
		rx: 40,
		fill: "#F7F7F7"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M45.3327 30.0833C47.463 30.0833 49.2042 31.7485 49.3259 33.8482L49.3327 34.0833V36.7499C51.463 36.7499 53.2042 38.4151 53.3259 40.5149L53.3327 40.7499V46.0833C53.3327 48.2136 51.6675 49.9548 49.5677 50.0765L49.3327 50.0833V51.3715C49.3327 52.7302 47.8089 53.4963 46.7267 52.7489L46.5991 52.6519L43.5166 50.0833H38.666C37.6428 50.0833 36.7092 49.699 36.0018 49.0669L35.8146 48.8885L33.3327 50.7499C32.2779 51.541 30.7907 50.8502 30.6734 49.5785L30.666 49.4166V47.4166C28.5358 47.4166 26.7945 45.7514 26.6728 43.6516L26.666 43.4166V34.0833C26.666 31.953 28.3312 30.2117 30.431 30.09L30.666 30.0833H45.3327ZM49.3327 39.4166H38.666C37.9296 39.4166 37.3327 40.0135 37.3327 40.7499V46.0833C37.3327 46.8197 37.9296 47.4166 38.666 47.4166H43.5166C44.1404 47.4166 44.7445 47.6353 45.2237 48.0347L46.6735 49.2427C46.7616 48.2195 47.62 47.4166 48.666 47.4166H49.3327C50.0691 47.4166 50.666 46.8197 50.666 46.0833V40.7499C50.666 40.0135 50.0691 39.4166 49.3327 39.4166ZM45.3327 32.7499H30.666C29.9296 32.7499 29.3327 33.3469 29.3327 34.0833V43.4166C29.3327 44.153 29.9296 44.7499 30.666 44.7499H31.3327C32.4373 44.7499 33.3327 45.6454 33.3327 46.7499V47.4166L34.6789 46.4069C34.6704 46.3002 34.666 46.1922 34.666 46.0833V40.7499C34.666 38.5407 36.4569 36.7499 38.666 36.7499H46.666V34.0833C46.666 33.3469 46.0691 32.7499 45.3327 32.7499Z",
		fill: "#8C8C8C"
	})]
});
export default SvgMessagesCircle;
